import { useEffect, useState } from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import { isAnyBlank } from '../../utils/string'
import css from './ModalEditarGuion.module.css'

const ModalEditarGuion = ({ open, guion, onClose, onSubmit, isLoading }) => {
  const [datos, setDatos] = useState({ nombre: '', asignaturas: [] })

  useEffect(() => {
    setDatos({
      nombre: guion?.nombre || '',
      asignaturas: guion?.asignaturas?.map(asignatura => asignatura.id) || []
    })
  }, [open, guion])

  const handleSubmit = () => {
    onSubmit({
      guion: guion.id,
      nombre: datos.nombre,
      asignaturas: datos.asignaturas
    })
  }

  const isSubmitDisabled = isAnyBlank(datos.nombre)

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='sm'>
      <DialogTitle>Editar guion</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.intro}>
          <TextField
            label='Nombre'
            value={datos.nombre}
            className={css.input}
            variant='standard'
            onChange={e => setDatos({ ...datos, nombre: e.target.value })}
          />
          <AsignaturaSelector
            multiple
            className={css.input}
            name='asignatura'
            label='Asignaturas'
            value={datos.asignaturas}
            onChange={(_e, value) =>
              setDatos({ ...datos, asignaturas: value.map(a => a.id) || [] })
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarGuion
